import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

const fetchVenueInfoData = (venueId) =>
  axios({
    url: `/api/venues/infomodal/${venueId}`,
  }).then((res) => res.data);

export const useVenueInfoQuery = (venueId) => {
  return useQuery(['venue-info', venueId], () => fetchVenueInfoData(venueId), {
    retry: 3,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 60 * 24,
  });
};
